import {CaptchaResponse, IdName} from '@core/src/public-api';

export class RegisterModel {
  hasVisitedBefore?: boolean;
  firstName?: string;
  surname1?: string;
  surname2?: string;
  identityDocument: IdentityDocument;
  healthCardDocument: HealthCard;
  email?: string;
  emailConfirm?: string;
  phone?: Phone;
  birthDate?: number;
  gender?: IdName;
  notificationLanguage?: string;
  password?: string;
  passwordConfirm?: string;
  nhc?: string;
  acceptPolicy?: boolean;
  acceptContactData?: boolean;
  verificationCode?: string;
  captchaResponse?: CaptchaResponse;
  resetCaptcha?: number;

  constructor() {
    this.identityDocument = new IdentityDocument();
    this.phone = new Phone();
    this.healthCardDocument = new HealthCard();
  }
}

export class IdentityDocument {
  type?: IdentityDocumentType;
  value?: string;
}

export class HealthCard {
  type?: HealthCardType;
  value?: string;
}

export class Phone {
  phoneCountry?: PhoneCountryType;
  value?: string;
}

export interface PhoneCountryType extends IdName {
  langCode?: string;
  phoneCode?: string;
  tld?: string;
  regex?: string;
  administrativeAreaLevel1?: boolean;
}

interface IdentityDocumentType extends IdName {
  regex?: string;
}

interface HealthCardType extends IdName {
  regex?: string;
}
